module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYKCV2/eEkAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4+MiAeHC4oDj40DD4+Hj4+Pj///9eU3DlAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABsSURBVAjXZY5BCoAwDASD+IGweBd9Qa29C/qBHPL/r7ht9RDdlIUMyaYyXkGHnDlol/yRZPcJNLDMjcCUgKZWHwhyQTMtsELg9G4Fz0qd0AasgXeFQy2DVxjv6m+GdkGRoAn/j62x32RYguYbIzoqswng2CAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Electric.png
// module id = 160
// module chunks = 0